module.exports = __webpack_public_path__ + "img/chadle1_1.78b98c39.png";